import React, { useState } from "react";
import "./DaysMonitored.css";

const DaysMonitored = () => {
  const [days, setDays] = useState(99);
  const [showInput, setShowInput] = useState(false);
  const [email, setEmail] = useState("");

  const handleEnable = () => setShowInput(true);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (email) {
      setDays(1); // Simulate enabling monitoring
      setShowInput(false);
    }
  };

  return (
    <div className="metric-box">
      <div className="metric-label">JANE DOE</div>
      <div className="metric-value">{days}</div>
      <div className="metric-inline">
        <span className="metric-date">Days Monitored</span>
        {days === 0 && !showInput && (
          <button className="metric-enable-button" onClick={handleEnable}>
            Enable
          </button>
        )}
      </div>

      {showInput && (
        <form className="metric-form-inline" onSubmit={handleSubmit}>
          <input
            type="email"
            className="metric-email-input"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Email"
            required
          />
          <button type="submit" className="metric-submit-button-outline">
            Submit
          </button>
        </form>
      )}
    </div>
  );
};

export default DaysMonitored;
